import { io } from "socket.io-client";

const socketUrl = process.env.REACT_APP_API_URL;

// Prevent multiple socket instances
let socketInstance = null;

export const socket = (() => {
  if (!socketInstance) {
    socketInstance = io(socketUrl, {
      reconnectionAttempts: 3,
      timeout: 5000,
      transports: ["websocket"],
      autoConnect: false,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      randomizationFactor: 0.5
    });
  }
  return socketInstance;
})();
